import React from 'react';
import { Pagination as RsuitePagination } from 'rsuite';
import { LIMIT_OPTIONS } from '../services/paginationLimitService';

type LayoutType = 'total' | '-' | 'pager' | '|' | 'limit' | 'skip';

const LAYOUT: LayoutType[] = ['total', '-', 'limit', '|', 'pager', 'skip'];

interface Props {
  total: number;
  limit: number;
  activePage: number;
  onChangePage: (page: number) => void;
  onChangeLimit: (limit: number) => void;
}

export default function Pagination({
  total, limit, activePage, onChangePage, onChangeLimit,
}: Props): JSX.Element {
  return (
    <RsuitePagination
      prev
      next
      first
      last
      ellipsis
      boundaryLinks
      maxButtons={3}
      size="sm"
      layout={LAYOUT}
      total={total}
      limitOptions={LIMIT_OPTIONS}
      limit={limit}
      activePage={activePage}
      onChangePage={onChangePage}
      onChangeLimit={onChangeLimit}
    />
  );
}
